import Vue from 'vue'
import Elmahio from 'elmah.io.javascript'
import App from './App.vue'
import {router} from './router'
import store from './store'
import axios from 'axios'
import {settings} from './settings'
import Default from './templates/default.vue'
import NoSidebar from './templates/no-sidebar'
import { Fragment } from 'vue-fragment'
import Loader from './components/spinner/spinner.vue'
import Heading from './components/heading/heading.vue'
import PopOver from './components/popover/popover.vue'
import Alert from './components/alert/alert.vue'
import VueI18n from 'vue-i18n'
import { dictionary } from './dictionary'

Vue.config.productionTip = true

Vue.prototype.$axios = axios
Vue.prototype.$apiUrl = settings.apiUrl
Vue.component( 'default-template', Default)
Vue.component( 'no-sidebar-template', NoSidebar)
Vue.component( 'fragment', Fragment )
Vue.component( 'loader', Loader )
Vue.component( 'heading', Heading )
Vue.component( 'popover', PopOver )
Vue.component( 'alert', Alert )
Vue.use(VueI18n)

axios.interceptors.request.use(requestConfig => {

  if (store.getters['Token']) {

    requestConfig.headers['Authorization'] = `Bearer ${store.getters['Token']}`;
  }

  return requestConfig;
})

const getLocale = (language: string) => {
  const str: string = language,
        strPart: string[] = str.split('-', 1),
        isValid = ['sv', 'en'];

  if (language != undefined && isValid.includes(strPart[0])) {

    return strPart[0];
  }

  return 'sv';
}

const elmahio = new Elmahio({
  apiKey: settings.elmahioKey,
  logId: settings.elmahioId,
  application: settings.elmahioApplication
});

Vue.config.errorHandler = (error, a) =>
  elmahio.error(error.message, error)

const i18n = new VueI18n({
  locale: getLocale(navigator.language),
  fallbackLocale: 'sv',
  messages: dictionary
})

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
